// 图片懒加载混入 - 通用懒加载功能
export const lazyLoadingMixin = {
  data() {
    return {
      imageObserver: null,
      scrollHandler: null
    }
  },
  
  mounted() {
    // 延迟初始化懒加载，确保页面滚动位置已恢复
    this.$nextTick(() => {
      setTimeout(() => {
        this.initLazyLoading();
      }, 100);
    });
  },
  
  beforeUnmount() {
    // 清理事件监听器和observer
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
    }
    if (this.imageObserver) {
      this.imageObserver.disconnect();
    }
  },
  
  methods: {
    initLazyLoading() {
      // 首先确保所有图片都显示src中的默认图片
      const images = this.$el.querySelectorAll('img[data-src]');
      images.forEach(img => {
        img.style.opacity = '1';
        img.classList.remove('lazy');
      });

      // 存储observer引用以便后续使用
      this.imageObserver = null;

      if ('IntersectionObserver' in window) {
        this.imageObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              if (img.dataset.src && !img.dataset.loaded) {
                this.loadHighResImage(img);
                this.imageObserver.unobserve(img);
              }
            }
          });
        }, {
          rootMargin: '200px 0px', // 增大预加载范围
          threshold: [0, 0.1, 0.5] // 多个阈值确保更好的触发
        });

        images.forEach(img => {
          this.imageObserver.observe(img);
        });

        // 延迟执行初始视口检查，确保页面完全渲染
        setTimeout(() => {
          this.checkImagesInViewport(images);
        }, 200);

        // 添加滚动事件监听作为备用机制
        this.scrollHandler = this.throttle(() => {
          this.checkImagesInViewport(images);
        }, 100);
        
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        window.addEventListener('resize', this.scrollHandler, { passive: true });
      } else {
        // Fallback for browsers that don't support IntersectionObserver
        images.forEach(img => {
          if (img.dataset.src && !img.dataset.loaded) {
            this.loadHighResImage(img);
          }
        });
      }
    },
    
    checkImagesInViewport(images) {
      images.forEach(img => {
        if (img.dataset.src && !img.dataset.loaded) {
          const rect = img.getBoundingClientRect();
          const windowHeight = window.innerHeight || document.documentElement.clientHeight;
          const isInViewport = rect.top < windowHeight + 200 && rect.bottom > -200;
          
          if (isInViewport) {
            this.loadHighResImage(img);
            if (this.imageObserver) {
              this.imageObserver.unobserve(img);
            }
          }
        }
      });
    },
    
    throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      }
    },
    
    loadHighResImage(img) {
      const highResImg = new Image();
      
      highResImg.onload = () => {
        // 无缝切换到高清图片
        img.style.transition = 'opacity 0.3s ease-in-out';
        img.style.opacity = '0.7';
        
        setTimeout(() => {
          img.src = img.dataset.src;
          img.dataset.loaded = 'true';
          img.style.opacity = '1';
        }, 150);
      };
      
      highResImg.onerror = () => {
        // 如果高清图片加载失败，保持使用默认图片
        console.warn('Failed to load high-res image, keeping default:', img.dataset.src);
        img.dataset.loaded = 'true';
      };
      
      highResImg.src = img.dataset.src;
    }
  }
};

// 默认导出
export default lazyLoadingMixin;